import { ActionBar, ButtonVariant } from '@dreryk/react-components';

import { nfzLoginTranslationKeys } from '../../../translations';

import { NfzLoginFormController } from './NfzLoginForm.types';
import { useEzwmLoginCommand } from './NfzLoginSaveAction.hooks';
import { PasswordChangeEnabledFormBeanPart } from './fields/PasswordChangeEnabledField';
import { EzwmEnabledFormBeanPart } from './fields/EzwmEnabledField';

type EzwmLoginSaveActionProps = Pick<
   NfzLoginFormController<PasswordChangeEnabledFormBeanPart<false> & EzwmEnabledFormBeanPart<true>>,
   'handleSubmit'
> & { onSuccess: VoidFunction };

export const EzwmLoginSaveAction = (props: EzwmLoginSaveActionProps): JSX.Element => {
   const { executeAsync: loginToEzwm } = useEzwmLoginCommand({
      onSuccess: props.onSuccess,
   });

   return (
      <ActionBar.PrimaryButton
         testId={'nfzLoginSave'}
         label={nfzLoginTranslationKeys.saveAndConnect}
         onClick={props.handleSubmit(loginToEzwm)}
         variant={ButtonVariant.PRIMARY}
         order={1}
      />
   );
};
